<template>
  <!-- 查看隐患-->
  <el-dialog
    :before-close="handleClose"
    :visible.sync="drawer"
    title="隐患详情"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    append-to-body
    width="40%"
  >
    <div
      class="dialog_box"
      style="max-height: 500px;
        overflow-y: scroll;"
    >
      <div class="form-row-item-box">
        <div class="form-item-box" style="width:33%">
          <span>隐患编码:</span>
          <div>{{ detailsData.number }}</div>
        </div>
        <div class="form-item-box" style="width:33%">
          <span>隐患位置:</span>
          <div>
            {{ detailsData.location }}
          </div>
        </div>
        <div class="form-item-box" style="width:34%">
          <span>隐患描述:</span>
          <div>{{ detailsData.description }}</div>
        </div>
      </div>
      <div class="form-row-item-box">
        <div class="form-item-box" style="width:33%">
          <span>隐患类型:</span>
          <div>
            {{ detailsData.hazardType }}
          </div>
        </div>
        <div class="form-item-box" style="width:33%">
          <span>上报人:</span>
          <div>{{ detailsData.reportUserName }}</div>
        </div>
        <div class="form-item-box" style="width:34%">
          <span>上报时间:</span>
          <div>{{ detailsData.reportingTime }}</div>
        </div>
      </div>
      <div class="form-row-item-box">
        <div class="form-item-box" style="width:33%">
          <span>处理人:</span>
          <div>{{ detailsData.disposeUserName }}</div>
        </div>
        <div class="form-item-box" style="width:33%">
          <span>要求处理完成时间:</span>
          <div>{{ detailsData.duration }}小时</div>
        </div>
        <div class="form-item-box" style="width:34%">
          <span>是否允许转派:</span>
          <div>{{ detailsData.redeployStatus }}</div>
        </div>
      </div>
      <div class="form-row-item-box">
        <div class="form-item-box" style="width:33%">
          <span>隐患图片:</span>
          <div>
            <el-image
              v-if="detailsData.beforeRectification"
              style="width: 60px; height: 60px"
              :src="
                $store.state.config.fileUrl + detailsData.beforeRectification
              "
              :preview-src-list="[
                $store.state.config.fileUrl + detailsData.beforeRectification
              ]"
            >
            </el-image>
            <span v-else>暂无图片</span>
          </div>
        </div>
        <div class="form-item-box" style="width:33%">
          <span>整改后图片:</span>
          <div>
            <el-image
              v-if="detailsData.afterRectification"
              style="width: 60px; height: 60px"
              :src="
                $store.state.config.fileUrl + detailsData.afterRectification
              "
              :preview-src-list="[
                $store.state.config.fileUrl + detailsData.afterRectification
              ]"
            >
            </el-image>
            <span v-else>暂无图片</span>
          </div>
        </div>
        <div class="form-item-box" style="width:34%">
        </div>
      </div>
      <div class="form-row-item-box" v-if="detailsData.flowRecord">
        <div class="form-item-box" style="width:100%">
          <span>处理流水记录:</span>
          <el-timeline class="timeline">
            <el-timeline-item
              v-for="(item, index) in detailsData.flowRecord"
              :key="index"
              :timestamp="item.runningWaterTime"
              placement="top"
            >
              <el-card>
                <h5 v-if="item.sponsor">
                  {{ item.sponsor }} {{ item.action }}
                  {{ item.targetPerson }}
                </h5>
                <h5 v-else>{{ item.targetPerson }} {{ item.action }}</h5>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "HiddenDangerSuperviseDialog",
  components: {},
  props: {
    checkResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    hiddenDangerId: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      drawer: false,
      req: {
        hiddenDangerId: ""
      },
      // 隐患督办数据详情
      detailsData: {}
    };
  },
  created() {},
  mounted() {},
  watch: {
    checkResize: function(newVal) {
      if (newVal) {
        this.req.hiddenDangerId = this.hiddenDangerId;
        this.getSuperviseDetail();
      }
    }
  },
  computed: {
    hiddenDangerType() {
      return this.$store.state.select.hiddenDangerType;
    }
  },
  methods: {
    handleClose() {
      this.drawer = false;
    },
    // 查看隐患详情信息
    async getSuperviseDetail() {
      let res = await this.$Http.schoolHiddenDangerSuperviseDetail(this.req);
      if (res.code == 200) {
        this.drawer = true;
        this.detailsData = res.data;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../../../public/css/edu_pages.scss";
.form {
  padding: 20px;
  .el-form-item {
    .el-input,
    .textarea,
    .el-select {
      width: 100%;
    }
  }
}
</style>
